import React from 'react';

function PresenterIframePane({ iframeRef, title, src, isPinnedLayout }) {
  return (
    <div
      className={[
        'min-h-0 min-w-0 bg-gray-50 transition-[flex-basis,width] duration-300 ease-out',
        isPinnedLayout
          ? 'flex-1 h-full min-w-0'
          : 'absolute inset-0 h-full w-full',
      ].join(' ')}
    >
      <iframe
        ref={iframeRef}
        title={title}
        src={src}
        className="w-full h-full border-0"
        />
    </div>
  );
}

export default PresenterIframePane;
